import { defineStore } from 'pinia'

import { SoftwareInformation } from '@/client'

export type ExtendedApplicationInformation = SoftwareInformation & {
  connected?: boolean
}
type OnboardingDialogStoreState = {
  // Current Dialog Content
  currentContent?: unknown
  selectedIntegrations: ExtendedApplicationInformation[]
}

export const useOnboardingDialogStore = defineStore('onboardingDialogStore', {
  state: (): OnboardingDialogStoreState => ({
    currentContent: undefined,
    selectedIntegrations: [],
  }),
  actions: {
    addIntegration(integration: ExtendedApplicationInformation) {
      this.selectedIntegrations.push(integration)
    },
    removeIntegration(integration: ExtendedApplicationInformation) {
      const lenBefore = this.selectedIntegrations.length
      this.selectedIntegrations = this.selectedIntegrations.filter(
        (i) => i.name !== integration.name
      )
      if (lenBefore === this.selectedIntegrations.length) {
        return false
      }
      return true
    },
  },
})
